import { pointerWithin, rectIntersection, type CollisionDetection } from "@dnd-kit/core";

import {
    SCORING_PRIORITIES,
    type LeadPriorityScore,
} from "app/pages/sales-intelligence/domain/leads/types/lead-priority";

const SCORING_COLUMN_ID_SET = new Set<string>(SCORING_PRIORITIES);

const isScoringColumnId = (id: unknown): id is LeadPriorityScore =>
    typeof id === "string" && SCORING_COLUMN_ID_SET.has(id);

export const scoringBoardColumnCollisionDetection: CollisionDetection = (args) => {
    const pointerColumnCollisions = pointerWithin(args).filter((collision) => isScoringColumnId(collision.id));

    if (pointerColumnCollisions.length > 0) {
        return pointerColumnCollisions;
    }

    return rectIntersection(args).filter((collision) => isScoringColumnId(collision.id));
};

export const resolveHoveredScoringColumn = (
    overId: unknown,
    sourcePriority: LeadPriorityScore | undefined,
): LeadPriorityScore | null => {
    if (!isScoringColumnId(overId) || sourcePriority === overId) {
        return null;
    }

    return overId;
};
